"use client";

import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { EditableProfileWrapper } from "./EditableProfileWrapper";
import { ProfileDetailsForm } from "./forms/ProfileDetailsForm";
import { isCountryWithReverseNameOrder } from "@lib/utils/address";
import { formatDateOfBirth } from "@lib/utils/dateOfBirth";
import { activeSiteCountry, getCountry } from "@config/site/site-config";

export const EditableProfilePersonalDetails = ({ personalDetails, globalErrorHandler }) => {
    const { getMultiple } = useMicrocopy();
    const country = activeSiteCountry;

    const microcopies = (() => {
        return getMultiple(CommonCMS.page, [
            CommonCMS.edit,
            CommonCMS.gender.title,
            CommonCMS.profile.birthDateLabel,
            CommonCMS.profile.personalDetailsHeader,
            CommonCMS.profile.personalDetailsAriaText,
            CommonCMS.profile.termDefinitionSeparator,
        ]);
    })();

    const title = microcopies[CommonCMS.profile.personalDetailsHeader];
    const editButton = microcopies[CommonCMS.edit];
    const personalDetailsAriaText = microcopies[CommonCMS.profile.personalDetailsAriaText];
    const dateOfBirthLabel = microcopies[CommonCMS.profile.birthDateLabel];
    const genderLabel = microcopies[CommonCMS.gender.title];
    const termDefinitionSeparator = microcopies[CommonCMS.profile.termDefinitionSeparator] || ":";

    const dateOfBirth = personalDetails.convertedDateOfBirth
        ? `${dateOfBirthLabel}${termDefinitionSeparator} ${formatDateOfBirth(personalDetails.convertedDateOfBirth, country)}`
        : "";

    const countryCode = personalDetails?.phoneCountryCode || personalDetails?.countryCode || "";

    const phoneNumber = personalDetails.phoneNumber ? personalDetails.phoneNumber : "";
    const completePhone = phoneNumber ? `${countryCode} ${phoneNumber}` : "";
    const gender = personalDetails.gender
        ? `${genderLabel}${termDefinitionSeparator} ${personalDetails.gender}`
        : "";
    const firstName = personalDetails.firstName ? personalDetails.firstName : "";
    const lastName = personalDetails.lastName ? personalDetails.lastName : "";
    const phoneticFirstName = personalDetails.phoneticFirstName
        ? personalDetails.phoneticFirstName
        : "";
    const phoneticLastName = personalDetails.phoneticLastName
        ? personalDetails.phoneticLastName
        : "";
    const data = [
        isCountryWithReverseNameOrder(getCountry)
            ? `${lastName} ${firstName}`
            : `${firstName} ${lastName}`,
        isCountryWithReverseNameOrder(getCountry)
            ? `${phoneticLastName} ${phoneticFirstName}`
            : `${phoneticFirstName} ${phoneticLastName}`,
        completePhone,
        dateOfBirth,
        gender,
    ];

    return (
        <EditableProfileWrapper
            title={title}
            headers={{
                editButton,
                editButtonAria: personalDetailsAriaText,
            }}
            globalErrorHandler={globalErrorHandler}
            data={data}
        >
            <ProfileDetailsForm data={personalDetails} globalErrorHandler={globalErrorHandler} />
        </EditableProfileWrapper>
    );
};

export default EditableProfilePersonalDetails;
